import { render } from "./CompaniaSlasDano.vue?vue&type=template&id=19036a1c&scoped=true"
import script from "./CompaniaSlasDano.vue?vue&type=script&lang=js"
export * from "./CompaniaSlasDano.vue?vue&type=script&lang=js"

import "./CompaniaSlasDano.vue?vue&type=style&index=0&id=19036a1c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19036a1c"]])

export default __exports__